import axios from "axios";

import { getAuthHeader } from "../headers";

// ===================================================================================
//  GET FAQ
// ===================================================================================
export const faqLoading = () => {
	return {
		type: "FAQ_ARE_LOADING"
	};
};

export const faqError = error => {
	return {
		type: "FAQ_HAS_ERROR",
		error
	};
};

export const faqSuccess = data => {
	return {
		type: "FAQ_SUCCESS",
		data
	};
};

export function getFaq() {
	return (dispatch, getState) => {
		dispatch(faqLoading());

		const params = { language: process.env.REACT_APP_LANGUAGE };

		return axios
			.get(process.env.REACT_APP_API_URL + "faq", {
				headers: getAuthHeader(getState().user),
				params
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					dispatch(faqError(response.data.errors));
				} else {
					dispatch(faqSuccess(response.data));
					return Promise.resolve(response);
				}
			})
			.catch(err => {
				dispatch(faqError(err.response.data.message));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/faq.js